import { message } from 'antd';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { MessageType } from 'models/MessageType';
import { ClaimsPageState } from 'models';

import { QuickAction } from './components/QuickActions';
import { MyClaims } from './components/MyClaims';
import { ShortfallWarning } from './components/ShortfallWarning';

export interface ClaimQuery {
  patientMemberType?: string;
  claimType?: string;
  treatmentPeriod?: string;
}

interface ClaimsLocationState {
  type: ClaimsPageState;
  value?: string;
}

const ClaimsPage = (): JSX.Element => {
  const { t } = useTranslation();
  const { state } = useLocation();

  useEffect(() => {
    const locationState = state as ClaimsLocationState;
    if (locationState?.type === ClaimsPageState.CLAIM_DELETED) {
      message[MessageType.SUCCESS](t('claimDetails.deleteClaimSuccess', { referenceNo: locationState?.value }));
    }
  }, [state, t]);

  return (
    <>
      <QuickAction />

      <ShortfallWarning />

      <MyClaims />
    </>
  );
};

export default ClaimsPage;
